<template>
  <v-container ma-0 pa-0>
    <!--feed info card -->
    <FeedRequestBreakdownInfoCard/>

    <h2>{{$t('feeds.filter_breakdown_title')}}</h2>
    <date-range-picker class="caption mb-1" :dateRange="dateRange" @updated="setDateRange" :endUnlimited="true"
                       :width="datePickerWidth" :vertical="true" :attach="true" :min-end="dateRange.startDate">
    </date-range-picker>
    <span v-if="dateRangeInvalid" class="caption text-red">{{$t('invalid_date_range')}}</span>

    <h2 class="mt-4">{{$t('feeds.filter_feed_process_date')}}</h2>
    <date-picker attach id="feed-process-date" :date="processDate" :maxEnd="now" @updated="updatedDate"></date-picker>

    <!-- TODO: implement the functionality
    <v-layout row pt-4>
      <v-btn @click="apply" color="primary">{{$t('apply')}}</v-btn>
    </v-layout> -->
  </v-container>
</template>

<script>
  import FeedRequestBreakdownInfoCard from './FeedRequestBreakdownInfoCard'
  import DatePicker from '../date/DatePicker'
  import {mapMutations, mapState, mapActions} from 'vuex'
  import {
    SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE,
    CLEAR_FEED_BREAKDOWN_RESULTS,
    SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE
  } from '../../store/mutation-types'
  import moment from 'moment-es6'
  import FilterComponent from '../filter/FilterComponent'
  import DateRangePicker from '../date/DateRangePicker'
  import {GET_FEED_BREAKDOWN_INFO} from '../../store/action-types'

  export default {
    name: 'feed-request-breakdown-info-filter',
    props: ['feed'],
    data () {
      return {
        dateRangeInvalid: false,
        now: moment().format('YYYY-MM-DD')
      }
    },
    computed: {
      ...mapState({
        startDate: state => state.feeds.requestFromDate,
        endDate: state => state.feeds.requestToDate,
        loading: state => state.feeds.loading
      }),
      processDate () {
        return this.$store.state.feeds.processDate
      },
      dateRange () {
        return {
          startDate: this.startDate,
          endDate: this.endDate
        }
      },
      datePickerWidth () {
        return this.$vuetify.breakpoint.smAndUp ? 250 : 265
      }
    },
    methods: {
      ...mapMutations({
        dateFilterChange: SET_FEED_BREAKDOWN_DATE_FILTER_CHANGE,
        clearTable: CLEAR_FEED_BREAKDOWN_RESULTS
      }),
      ...mapActions({
        getBreakdownInfo: GET_FEED_BREAKDOWN_INFO
      }),
      setDateRange (newDateRange) {
        let diff = moment(this.dateRange.endDate).diff(moment(this.dateRange.startDate), 'days')
        if (diff >= 0) {
          this.dateRangeInvalid = false
          this.dateFilterChange({
            startDate: newDateRange.startDate,
            endDate: newDateRange.endDate
          })
          this.clearTable()
          this.getBreakdownInfo()
        } else {
          this.dateRangeInvalid = true
        }
      },
      apply () {
        this.clearTable()
        this.getBreakdownInfo()
      },
      updatedDate (value) {
        this.$store.commit(SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE, value)
        this.clearTable()
        this.getBreakdownInfo()
      }
    },
    created () {
      this.$store.commit(SET_FEED_BREAKDOWN_PROCESS_DATE_CHANGE, '')
    },
    components: {
      FilterComponent,
      DateRangePicker,
      DatePicker,
      FeedRequestBreakdownInfoCard
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: auto;

  }

  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfoFilter.vue